import { useCallback } from 'react';

import { useTelemetry } from '@order/Telemetry';

export const useCustomizationTelemetry = () => {
  const { track } = useTelemetry();

  const trackIngredientsTabPressed = useCallback(() => {
    track('customization.ingredients-tab.pressed');
  }, [track]);

  const trackReviewTabPressed = useCallback(() => {
    track('customization.review-tab.pressed');
  }, [track]);

  const trackIngredientsTabIngredientAdded = useCallback(() => {
    track('customization.ingredients-tab.ingredient-added');
  }, [track]);

  const trackIngredientsTabIngredientRemoved = useCallback(() => {
    track('customization.ingredients-tab.ingredient-removed');
  }, [track]);

  const trackReviewTabIngredientAdded = useCallback(() => {
    track('customization.review-tab.ingredient-added');
  }, [track]);

  const trackReviewTabIngredientRemoved = useCallback(() => {
    track('customization.review-tab.ingredient-removed');
  }, [track]);

  const trackReviewTabAddFromSectionTapped = useCallback(
    (section: string) => {
      track('customization.review-tab.add-from-section-tapped', { section });
    },
    [track],
  );

  const trackDressingOnTheSideTapped = useCallback(() => {
    track('customization.dressing.on-the-side.tapped');
  }, [track]);

  const trackDressingMixedInTapped = useCallback(() => {
    track('customization.dressing.mixed-in.tapped');
  }, [track]);

  const trackDressingBreadTapped = useCallback(() => {
    track('customization.dressing.bread.tapped');
  }, [track]);

  return {
    trackIngredientsTabPressed,
    trackReviewTabPressed,
    trackIngredientsTabIngredientAdded,
    trackIngredientsTabIngredientRemoved,
    trackReviewTabIngredientAdded,
    trackReviewTabIngredientRemoved,
    trackReviewTabAddFromSectionTapped,
    trackDressingOnTheSideTapped,
    trackDressingMixedInTapped,
    trackDressingBreadTapped,
  };
};
